import React from 'react';

import { AccountGroupLevelInvestmentStyleCard } from './AccountGroupLevelInvestmentStyleCard';
import { AccountLevelInvestmentStyleOverridesCard } from './AccountLevelInvestmentStyleOverridesCard';

export const InvestmentStylesTab = () => {
    return (
        <div className="space-y-4">
            <div className="grid grid-cols-3 items-start gap-4">
                <AccountGroupLevelInvestmentStyleCard />
                <AccountLevelInvestmentStyleOverridesCard className="col-span-2" />
            </div>
        </div>
    );
};
